import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import { AbbreviatedNumber } from '../../../../../../../src/components/common/number';
import Text from '../../../../../../../src/components/common/text';
import { NO_DATA } from '../../../../../../../src/constants';
import { injectIntl } from 'react-intl';

function AssetItemDataText(props) {
  const { value } = props;

  if (value === null || value === undefined) {
    return (
      <div aria-label={props.intl.messages['app.common.nullValue']}>
        <Text>{NO_DATA}</Text>
      </div>
    )
  }


  if (typeof value !== 'number') {
    return null;
  }
  return (
    <AbbreviatedNumber
      renderProps={{ size: 'small' }}
      renderExactAs="currency"
      // maxDigits={30}
      maxDecimals={2}
      maxDigitsIncludeDecimals={true}
      value={value}
    />
  );
}

AssetItemDataText.propTypes = {
  value: PropTypes.number,
};


AssetItemDataText.contextTypes = {
  intl: PropTypes.object,
};


export default pure(injectIntl(AssetItemDataText));
